import { useFormContext } from 'react-hook-form';
import { ClientOnboardingForm, ClientType } from '../../../api';
import ClientTypeCard from './ClientTypeCard';
import GeneralInfoCard from './GeneralInfoCard';
import SystemsCard from './SystemsCard';

/**
 * Profile section — the consolidation of the old "Systems & Type" and
 * "General Info" steps: platforms, client type / sub-type / office / business
 * unit / identity, and (for person types) the individual + spouse name block.
 * Reuses the existing sub-cards verbatim; field-level conditional logic is
 * unchanged.
 */
const ProfileCard = () => {
    const { watch } = useFormContext<ClientOnboardingForm>();
    const clientType = watch('clientType');
    const isPerson = clientType === ClientType.Individual || clientType === ClientType.Staff;

    return (
        <>
            <SystemsCard />
            <ClientTypeCard />
            {isPerson && <GeneralInfoCard />}
        </>
    );
};

export default ProfileCard;
